import React from "react";
import TranslationContext from "./TranslationContext";
export const TranslationProvider = ({ t, children, }) => {
    return (React.createElement(TranslationContext.Provider, { value: t }, children));
};
